// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/card/style/index.less
// module id = 1016
// module chunks = 1